import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Admins } from "../model";
import { Subscription } from "rxjs";
import { AuthService } from "../../authServices";
import { AdminProfileService } from "../api.service";
import { FormControl, FormGroup } from "@angular/forms";
import icClose from "@iconify/icons-ic/twotone-close";
import icDelete from "@iconify/icons-ic/twotone-delete";
import { fadeInUp400ms } from "../../../../../@vex/animations/fade-in-up.animation";
import { fadeInRight400ms } from "../../../../../@vex/animations/fade-in-right.animation";
import { scaleIn400ms } from "../../../../../@vex/animations/scale-in.animation";
import { stagger40ms } from "../../../../../@vex/animations/stagger.animation";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "vex-update-profile",
  templateUrl: "./update-profile.component.html",
  styleUrls: ["./update-profile.component.scss"],
  animations: [fadeInUp400ms, fadeInRight400ms, scaleIn400ms, stagger40ms],
})
export class UpdateProfileComponent implements OnInit {
  data: any;
  form: FormGroup;
  isLoading: boolean;
  userIsAuthenticated = false;
  userId: string;
  imagePreview: string | ArrayBuffer;
  private authStatusSub: Subscription;
  isDragOver: any;
  icClose = icClose;
  icDelete = icDelete;
  isUploading: boolean;
  constructor(
    private authService: AuthService,
    public service: AdminProfileService,
    @Inject(MAT_DIALOG_DATA) public row: any,
    public dialogRef: MatDialogRef<UpdateProfileComponent>,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.form = new FormGroup({
      profile_image: new FormControl(null),
    });
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe((isAuthenticated) => {
        this.userIsAuthenticated = isAuthenticated;
      });
    this.userId = this.authService.getUserId();
    this.service.getByID(this.userId).subscribe((data) => {
      this.isLoading = false;
      this.data = data.data.data;
      if (this.data) {
        this.imagePreview =
          this.data.profile_image !== null &&
          this.data.profile_image !== "null" &&
          this.data.profile_image !== ""
            ? this.data.profile_image
            : "assets/user.png";
        this.form.controls.profile_image.setValue(
          this.data.profile_image || "assets/user.png"
        );
      }
    });
  }

  onImagePicked(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.form.patchValue({ profile_image: file });
    this.form.get("profile_image").updateValueAndValidity();
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result;
    };
    reader.readAsDataURL(file);
  }

  onClearImage() {
    this.imagePreview = null;
    this.form.get("profile_image").setValue(null);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  // Handle drag leave event
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  // Handle drop event
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
    const files = event.dataTransfer?.files;
    if (files?.length) {
      const file = files[0];
      if (this.isValidFileType(file)) {
        this.onImagePicked({ target: { files } } as any);
      } else {
        this.toastr.error("Only .png, .jpg and .jpeg files are allowed!");
      }
    }
  }

  isValidFileType(file: File): boolean {
    const validExtensions = [".png", ".jpg", ".jpeg"];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    return validExtensions.includes(`.${fileExtension}`);
  }

  get profile_image() {
    return this.form.get("profile_image");
  }

  onSave() {
    if (this.form.invalid) return;

    if (this.row) {
      this.isUploading = true;

      this.service.updateProfilePic(this.form.value.profile_image).subscribe({
        next: () => {
          this.isUploading = false;
          this.toastr.success("Profile pic updated successfully!");
          this.dialogRef.close('profile-updated');
        },
        error: () => {
          this.isUploading = false;
          this.toastr.error("Failed to update profile pic.");
        },
      });
    }
  }

  onClose() {
    this.form.reset();
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.authStatusSub.unsubscribe();
  }
}
